import { render, staticRenderFns } from "./LandingBlackFridayPage.vue?vue&type=template&id=0fbd646c&scoped=true"
import script from "./LandingBlackFridayPage.vue?vue&type=script&lang=js"
export * from "./LandingBlackFridayPage.vue?vue&type=script&lang=js"
import style0 from "./LandingBlackFridayPage.vue?vue&type=style&index=0&id=0fbd646c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbd646c",
  null
  
)

export default component.exports